export default __webpack_public_path__ + "static/media/img3.22cf9d82.png";